import { useCallback } from "react";
import useList from "../../../../../../shared/hooks/useList";
import ClassifierService from "services/ClassifierService";
import Classifier from "models/ClassifierModel";

export const usePublishedClassifiers = (organizationId: string) => {
    const getData = useCallback(async () => {
        return new ClassifierService().getPublishedClassifiers(organizationId);
    }, [organizationId]);

    const {
        isLoading,
        data: publishedClassifiers,
        refetch,
    } = useList<Classifier>({
        get: getData,
    });

    return {
        publishedClassifiers,
        isLoading,
        refetch,
    };
};
